<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('ChargeList.name')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
                        <el-form-item :label="$t('ChargeList.usdt_url')" class="mb-0">
							<el-input size="small" v-model="from.usdt_url" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('ChargeList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center"  prop="sort" :label="$t('ChargeList.sort')">
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('ChargeList.name')">
				</el-table-column>
                <el-table-column align="center" prop="usdt_url" :label="$t('ChargeList.usdt_url')">
				</el-table-column>
                <el-table-column align="center" prop="msg" :label="$t('ChargeList.msg')">
                    <template slot-scope="scope">
									<div v-if="scope.row.msg.length > 20">
										{{ scope.row.msg.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.msg)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										{{ scope.row.msg }}
									</div>
								</template>
				</el-table-column>
                <el-table-column align="center" prop="status" width="100" :label="$t('status.status')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('status.normal') : $t('status.disable')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val"  @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


        
		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('ChargeList.edit') : $t('ChargeList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
            @close="hide" 
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('ChargeList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'3',cms_type:'1'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
                <el-form-item :label="$t('ChargeList.sort')" prop="sort">
					<el-input v-model="form.sort"  clearable size="small" :placeholder="$t('ChargeList.sort')"  style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('ChargeList.name')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('ChargeList.name')"  style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item :label="$t('ChargeList.usdt_url')" prop="usdt_url">
					<el-input v-model="form.usdt_url"  clearable size="small" :placeholder="$t('ChargeList.usdt_url')"  style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item :label="$t('ChargeList.msg')" prop="msg">
					<el-input v-model="form.msg"  type="textarea" clearable size="small" :placeholder="$t('ChargeList.msg')"  style="width: 85%;"></el-input>
				</el-form-item>
            
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

        

        <el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('cloudList.loginUrl')">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,

                dialogTitleVisible:false,
                fullTitle: '',
				//搜索數据
				from: {
					name: '',
					usdt_url: '',
					time:[],
				},
				auth_val: 'Charge',

                prop: 'sort',
                sort: 'ascending',

				preUrl: "data/chargeList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "data/delCharge", //删除單条地址
				addUrl: "data/addCharge", //添加/修改地址
				editStatusUrl:"data/editStatusCharge",//修改狀態地址

				tableData: [],
				form: {
                    name: "",
                    usdt_url: '',
                    msg: '',
                    icon: '',
                    sort: 0,
                    imgUrl: '',
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('ChargeList.nameRequired'),
						trigger: 'blur',
					}],
					usdt_url: [{
						required: true,
						message: this.$t('ChargeList.addressRequired'),
						trigger: 'blur',
					}],
                    
					
				},
				Charge_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['Charge']);
		},
		methods: {
            
             // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('ChargeList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('ChargeList.differentPasswords'),
						type: 'error'
					});
                    this.submitLoading = false;
					return
				}
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
                        usdt_url: '',
                        msg: '',
                        sort: 0,
                        icon: '',
                        imgUrl: '',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						usdt_url: e.row.usdt_url,
						msg:  e.row.msg,
						sort:  e.row.sort,
						imgUrl:  e.row.img_url,
						icon:  e.row.img_url,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.Charge_list = list.Charge

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
            handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.imgUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 12;

				if (!isJPG) {
				this.$message.error(this.$t('message.info_err'));
				}
				if (!isLt2M) {
				this.$message.error(this.$t('message.img_max_err'));
				}
				return isJPG && isLt2M;
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
            hide(){
                this.form = {
						name: "",
                        usdt_url: '',
                        msg: '',
                        sort: 0,
                        icon: '',
                        imgUrl: '',
					}
                    this.editIndex = -1
                    this.createModel = false
            },
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					usdt_url: '',
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
